import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d8a0160"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "acCalendar" }
const _hoisted_2 = { class: "acCalendar_course course" }
const _hoisted_3 = { class: "course_header" }
const _hoisted_4 = { class: "course_coach" }
const _hoisted_5 = { class: "course_coach_wrapper" }
const _hoisted_6 = { class: "course_actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2449_833)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2 6.74551C1.99961 6.15466 2.11576 5.56954 2.34183 5.02365C2.56789 4.47775 2.89941 3.98182 3.31741 3.56423C3.73541 3.14665 4.23168 2.81562 4.7778 2.59011C5.32392 2.36459 5.90915 2.24902 6.5 2.25001H12.5C14.9848 2.25001 17 4.27126 17 6.74551V15.75H6.5C4.01525 15.75 2 13.7288 2 11.2545V6.74551ZM15.5 14.25V6.74551C15.498 5.95088 15.1812 5.18943 14.6189 4.62797C14.0565 4.0665 13.2946 3.7508 12.5 3.75001H6.5C6.10614 3.74902 5.71595 3.82579 5.35182 3.97593C4.98769 4.12606 4.65678 4.3466 4.37807 4.62489C4.09936 4.90319 3.87832 5.23377 3.72764 5.59767C3.57696 5.96157 3.4996 6.35164 3.5 6.74551V11.2545C3.50199 12.0491 3.81884 12.8106 4.38114 13.372C4.94345 13.9335 5.70537 14.2492 6.5 14.25H15.5ZM11 8.25001H12.5V9.75001H11V8.25001ZM6.5 8.25001H8V9.75001H6.5V8.25001Z",
      fill: "#3C92FE"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2449_833" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "18",
        height: "18",
        fill: "white",
        transform: "translate(0.5)"
      })
    ])
  ])
], -1))
const _hoisted_8 = { class: "course_title" }
const _hoisted_9 = { class: "course_subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_homework = _resolveComponent("homework")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_alert = _resolveComponent("alert")!
  const _component_day = _resolveComponent("day")!
  const _component_days = _resolveComponent("days")!
  const _component_stage = _resolveComponent("stage")!
  const _component_stages = _resolveComponent("stages")!
  const _component_as_preloader = _resolveComponent("as-preloader")!
  const _component_ac_on_boarding = _resolveComponent("ac-on-boarding")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.course.coachName), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_ac_button, {
                      class: "course_action -chat",
                      variant: "outlined",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToChat()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('messages')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.course.caption) + " ", 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.course.excerpt), 1)
                ])
              ])
            ]),
            _createVNode(_component_stages, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stages, (stage) => {
                  return (_openBlock(), _createBlock(_component_stage, {
                    key: `stage-${stage.stage.id}`,
                    stage: stage,
                    stream: _ctx.stream
                  }, {
                    homeworksBefore: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stage.homeworks, (homework) => {
                        return (_openBlock(), _createBlock(_component_homework, {
                          key: `homework-${homework.id}`,
                          "homework-status": homework.status,
                          homework: homework,
                          "stage-status": _ctx.checkStageIsOpenForHomeworks(stage),
                          "gamification-enabled": _ctx.isGamificationEnabled,
                          "stream-id": _ctx.stream.id,
                          class: "acCalendar_homeworksBefore"
                        }, null, 8, ["homework-status", "homework", "stage-status", "gamification-enabled", "stream-id"]))
                      }), 128))
                    ]),
                    alertBefore: _withCtx(() => [
                      (stage.isShowWarningBefore)
                        ? (_openBlock(), _createBlock(_component_alert, {
                            key: 0,
                            class: "acCalendar_alert"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('requestHomeworkBefore')) + " ", 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stage.homeworksRequiredBefore, (h, id) => {
                                return (_openBlock(), _createBlock(_component_router_link, {
                                  key: `hlink${id}`,
                                  to: h.link,
                                  class: "-link",
                                  "data-cy": `asWarning_homework_${h.status.id}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(h.homework.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "data-cy"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_days, {
                        class: "acCalendar_days",
                        status: stage.status.status
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stage.days, (day) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "acCalendar_day",
                              key: `dayWrapper-${day.day.id}`
                            }, [
                              (_openBlock(), _createBlock(_component_day, {
                                day: day,
                                "stage-status": stage.status.status,
                                key: `day-${day.day.id}`
                              }, null, 8, ["day", "stage-status"])),
                              (day.hasHomework && day.status)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(day.homeworkStatuses, (homework) => {
                                    return (_openBlock(), _createBlock(_component_homework, {
                                      key: `homework-${homework.id}`,
                                      "homework-status": homework,
                                      "day-status": day.status,
                                      "stage-status": stage.status.status,
                                      "gamification-enabled": _ctx.isGamificationEnabled,
                                      "stream-id": _ctx.stream.id
                                    }, null, 8, ["homework-status", "day-status", "stage-status", "gamification-enabled", "stream-id"]))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["status"])
                    ]),
                    alertAfter: _withCtx(() => [
                      (stage.isRequestToComplete)
                        ? (_openBlock(), _createBlock(_component_alert, {
                            key: 0,
                            class: "acCalendar_alert"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('warningRequestToComplete')) + " " + _toDisplayString(stage.titleDaysRequiredToComplete), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["stage", "stream"]))
                }), 128))
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(_component_as_preloader, { key: 1 }))
    ]),
    _createVNode(_component_ac_on_boarding, {
      steps: _ctx.stepsOnBoarding,
      "stream-id": _ctx.stream.id
    }, null, 8, ["steps", "stream-id"])
  ], 64))
}